import { ValueCache } from '@leverege/value-cache';
import { TableModel, Columns, Attributes } from '@leverege/ui-attributes';
import DashboardPluginSetup from './dashboard/PluginSetup';
import JobItemAttributesPluginSetup from './jobItemAttributes/PluginSetup';
import ActionsPluginSetup from './actions/PluginSetup';
const cache = new ValueCache();
const INCLUDE_TAG = 'include:table';
const itemModels = [{
  alias: 'jobItem'
}];
const subtype = null;
export default {
  install(molten) {
    DashboardPluginSetup.install(molten);
    JobItemAttributesPluginSetup.install(molten);
    ActionsPluginSetup.install(molten);
    itemModels.forEach(itemModel => molten.addPlugin('DefaultTableModel', {
      id: `${itemModel.alias}.DefaultTableModel`,
      type: `${itemModel.alias}`,
      create: addName => {
        if (cache.isSame(itemModel, subtype, addName)) {
          return cache.value;
        }
        const allColumns = Columns.getColumnsFor(`${itemModel.alias}`).map(col => col.create());
        let tModel = TableModel.create();
        const columns = [];
        if (addName) {
          const nameAttr = allColumns.find(col => col.attrName === `${itemModel.alias}.deviceName`);
          if (nameAttr) {
            columns.push(nameAttr);
          }
        }
        const attributes = Attributes.getAttributesFor(itemModel.alias);
        if (attributes) {
          attributes.forEach(attr => {
            if (attr?.blueprint?.attr?.tags && attr.blueprint.attr.tags.includes(INCLUDE_TAG)) {
              const colAttr = allColumns.find(col => col.attrName === `${itemModel.alias}.${attr.name}`);
              if (colAttr) {
                columns.push(colAttr);
              }
            }
          });
        }
        tModel = TableModel.setColumns(tModel, columns);
        return cache.set(tModel, itemModel, subtype, addName);
      }
    }));
  }
};